import { AbstractService } from '@uniqoders/sdk';

export default class MenuService extends AbstractService {
  /**
   * Retrieve all CMS menus for an agency
   */
  public listCmsMenus(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/menus', { agency }),
      params,
    });
  }

  /**
   * Retrieve a single CMS menu item
   */
  public getCmsMenu(agency: string, cmsMenuId: number, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/menus/{cmsMenuId}', { agency, cmsMenuId }),
      params,
      headers,
    });
  }

  /**
   * Create a new CMS menu item
   */
  public createCmsMenu(agency: string, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/menus', { agency }),
      data,
    });
  }

  /**
   * Update an existing CMS menu item
   */
  public updateCmsMenu(agency: string, cmsMenuId: number, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/menus/{cmsMenuId}', { agency, cmsMenuId }),
      data,
    });
  }

  /**
   * Delete a CMS menu item
   */
  public deleteCmsMenu(agency: string, cmsMenuId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/menus/{cmsMenuId}', { agency, cmsMenuId }),
    });
  }

  /**
   * Reorder menu items
   */
  public reorderMenus(agency: string, menuIds: number[]): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/menus/reorder', { agency }),
      data: { menu_ids: menuIds },
    });
  }
}

